import { Box } from "@/components/essentials/box";
import { Typography } from "@/components/essentials/typography";
import { Flex } from "@chakra-ui/react";
import { useState, type FC } from "react";
import { BirthdayForm } from "@/components/fragments/forms/birthday-form";
import { ChildSexForm } from "@/components/fragments/forms/child-sex-form";
import { childFormBirthdayField, childFormDescriptionTestId, childFormTestId, childFormTitleTestId } from "./const";
import { Button } from "@/components/essentials/button";
import { FadeableBox } from "@/components/fragments/box/fadeable-box/FadeableBox";
import { useFormContext } from "react-hook-form";
import { ChatInputBox } from "@/components/fragments/box/chat-input-box";

interface ChildFormProps {
  readonly isStepwise?: boolean;
  readonly showChatBalloon?: boolean;

  readonly onCompleteAllSteps?: () => void;
}

export const ChildForm: FC<ChildFormProps> = ({ isStepwise = false, showChatBalloon = false, onCompleteAllSteps }) => {
  const {
    formState: { isValid },
  } = useFormContext();

  const [formStepIndex, setFormStepIndex] = useState<number>(0);

  return (
    <Flex flexDir="column" gridGap="10" data-testid={childFormTestId}>
      {!showChatBalloon && (
        <Box wordBreak="break-word" textAlign="center">
          <Typography variant="display3" data-testid={childFormTitleTestId}>
            お子さまについて
          </Typography>
          <Typography variant="text4" color="gray.dark" data-testid={childFormDescriptionTestId}>
            お子様の性別と生年月日を入力してください。
          </Typography>
        </Box>
      )}
      <ChatInputBox showChatBalloon={showChatBalloon} title="お子さまについて教えてください">
        <Flex flexDir="column" gridGap="1.5rem">
          <BirthdayForm
            birthdayField={childFormBirthdayField}
            formLabel="お子さまの生年月日"
            formSubLabel="現在妊娠中の場合、出産予定日をご入力ください"
            isDisplayAge
          />
          <FadeableBox fadeInCondition={formStepIndex >= 1} isAlwaysDisplay={!isStepwise}>
            <ChildSexForm />
          </FadeableBox>
        </Flex>
      </ChatInputBox>
      {isStepwise && formStepIndex <= 1 && (
        <Button
          type="button"
          size="md"
          m="auto"
          onClick={() => {
            if (formStepIndex === 1 && onCompleteAllSteps) {
              onCompleteAllSteps();
            }

            setFormStepIndex((current: number) => current + 1);
          }}
          isDisabled={!isValid}
        >
          次へ
        </Button>
      )}
    </Flex>
  );
};
